import { render, staticRenderFns } from "./NewsStyleOne.vue?vue&type=template&id=c32580ba&scoped=true&"
import script from "./NewsStyleOne.vue?vue&type=script&lang=ts&"
export * from "./NewsStyleOne.vue?vue&type=script&lang=ts&"
import style0 from "./NewsStyleOne.vue?vue&type=style&index=0&id=c32580ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32580ba",
  null
  
)

export default component.exports